<template>
  <div
      :class="{
      'avatar-meta': true,
      editable: editable
    }"
      :style="{height: size + 'px', width: size + 'px'}"
      @click="event => $emit('click', event)">
    <v-avatar
        v-if="avatar || avatarURL"
        size="size"
        class="image"
        :class="{'elevation-2': shadow}"
        :style="{
        'background-color': notificationColor,
        height: size + 'px',
        width: size + 'px',
        overflow: 'hidden',
        opacity: avatarURLResolves ? 1 : 0
      }">
      <img ref="image" src="" @load="avatarURLResolves = true" :alt="computedALT"
           :style="{height: size + 'px', width: size + 'px'}">
      <span v-if="editable" class="edit">
        <span class="text">{{$tf('Change')}}</span>
      </span>
    </v-avatar>
    <v-avatar
        size="size"
        class="letter"
        :class="{'elevation-2': shadow}"
        :style="{
        'background-color': color || avatarColor(computedALT),
        height: size + 'px',
        width: size + 'px',
        overflow: 'hidden',
        opacity: avatarURLResolves ? 0 : 1
      }">
      <span class="white--text" :style="{
        'font-size': (size*0.75) + 'px'
      }" style="cursor: inherit" v-if="computedALT">{{computedALT.charAt(0).toUpperCase()}}</span>
      <v-icon v-if="!computedALT && computedIcon"
              :class="{'white--text': tinycolor(color || avatarColor(computedALT)).isDark()}"
              :style="{'font-size': (size*0.75) + 'px'}">{{computedIcon}}
      </v-icon>
      <span v-if="editable" class="edit">
        <span class="text">{{$tf('Change')}}</span>
      </span>
    </v-avatar>
  </div>
</template>

<script>
  import colorHelper from '~/helpers/color'
  import { IconFromType } from '~/helpers/icon.js'
  import { GetAccountName } from '~/helpers/account'
  import Api from '~/store/idonia-api/api.js'

  export default {
    name: 'avatar',
    props: {
      shadow: {
        type: Boolean,
        default: false
      },
      avatar: {
        type: String,
        default: ''
      },
      icon: String,
      type: String,
      size: {
        type: [Number, String],
        required: false
      },
      alt: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: ''
      },
      editable: {
        type: Boolean,
        default: false
      },
      account: Object,
      updated: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        avatarColor: colorHelper.fromName,
        tinycolor: require('tinycolor2'),
        avatarURLResolves: false,
        notificationColor: ''
      }
    },
    computed: {
      computedIcon () {
        return this.icon ? this.icon : IconFromType(this.type)
      },
      avatarURL () {
        if (this.avatar && this.avatar.substring(0, 4) === 'http') {
          return this.avatar
        }

        if (typeof this.account !== 'undefined' && typeof this.account.account_id !== 'undefined' && (this.account.avatar || this.account.has_avatar || this.updated)) {
          let path = this.account.thumbnail || `account/${this.account.account_id}/avatar`
          return this.$config.apiUrl + path + `?_=` + this.updated
        } else if (typeof this.account === 'string' && (this.avatar || this.updated)) {
          if (this.avatar.includes('/')) {
            return this.$config.apiUrl + this.avatar
          } else if (this.avatar.length === 1) {
            return this.$config.apiUrl + `account/${this.avatar}/avatar?_=` + this.updated
          }
        } else if (typeof this.account !== 'string' && this.avatar && this.avatar.includes('/')) {
          this.notificationColor = 'white'
          return location.protocol + '//' + window.location.hostname + ':' + window.location.port + this.avatar
        }

        return null
      },
      computedALT () {
        if (typeof this.account !== 'undefined' && (this.account.firstname || this.account.lastname || this.account.username)) {
          return GetAccountName(this.account)
        }
        return this.alt
      }
    },
    watch: {
      avatarURL: {
        immediate: true,
        handler (val) {
          if (!val) {
            return
          }
          let img = new Image()
          img.onload = () => {
            if (this.$refs['image']) {
              this.$refs['image'].src = img.src
            }
          }
          fetch(val, {headers: Api.getAuthHeaders(), credentials: 'include'}).then(res => res.blob()).then(blob => {
            img.src = URL.createObjectURL(blob)
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avatar-meta {
    position: relative;
    cursor: pointer;

    .avatar {
      display: flex;
      justify-content: center;
      vertical-align: middle;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      transition: opacity .2s ease-out;
      min-width: 0 !important;
      user-select: none;
      z-index: 1;
    }

    &.editable {
      cursor: pointer;

      .edit {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.5);
        padding: .15rem 0 .25rem;
        color: #fff;
        font-size: .65rem;
        font-weight: bold;
        cursor: pointer;
        transition: .2s ease-out;
        top: 75%;

        .text {
          transition: .2s ease-out;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      &:hover {
        .edit {
          top: 0%;
          background-color: rgba(0, 0, 0, 0.75);
          .text {
            font-size: 1rem;
          }
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Avatar.vue